import React from 'react'
import PropTypes from 'prop-types'
import ColoredProgressBar from '/src/ui/core/progress_bars/colored_progress_bar'
import I18n from '/src/utils/translations'
import { progress, percentage, formatTime } from '/src/ui/domain/progress_services/productivity_factor_block_helper'

export default function PFHoursProgressBar({ dataItem }) {
  return (
    <div className="pf-hours-progress-section">
      <div className="pf-hours-progress-title">
        {I18n.t('progress_services.actual_div_hours')}
      </div>
      <div className="pf-hours-progress-bar">
        <ColoredProgressBar
          progress={progress(dataItem, 'progress_service_summary.actual_hours', 'team_target_hours')}
        />
      </div>
      <div className="pf-hours-progress-calculation">
        <div className="pf-hours-progress-equation">
          <span className="pf-hours-progress-actual">
            {formatTime(dataItem, 'progress_service_summary.actual_hours')}
          </span>
          <span className="pf-hours-progress-divided">
            {' / '}
          </span>
          <span className="pf-hours-progress-scoped">
            {formatTime(dataItem, 'team_target_hours')}
          </span>
        </div>
        <span className="pf-hours-progress-value">
          {percentage(dataItem, 'progress_service_summary.actual_hours', 'team_target_hours')}
        </span>
      </div>
    </div>
  )
}

PFHoursProgressBar.propTypes = {
  dataItem: PropTypes.oneOfType([PropTypes.object])
}

PFHoursProgressBar.defaultProps = {
  dataItem: {}
}
